// @flow

import React, { useContext } from "react";
import { TitleBar } from "@shopify/app-bridge-react";
import { NavigationContext } from "contexts/Navigation";

const CommonTitleBar = () => {
  const navigation = useContext(NavigationContext);
  const navigateToNewOffer = () => navigation.goTo("/offers/new");

  return (
    <TitleBar>
      <button variant="primary" onClick={navigateToNewOffer}>
        Create special offer
      </button>
      <section label="Menu">
        <button onClick={() => navigation.goTo("/settings")}>Settings</button>
        <button onClick={() => navigation.goTo("/appearance")}>
          Appearance
        </button>
        <button onClick={() => navigation.goTo("/feature-requests")}>
          Feature Requests
        </button>
        <button onClick={() => navigation.goTo("/account")}>Account</button>
      </section>
    </TitleBar>
  );
};

export default CommonTitleBar;
